var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ES6Set from '@byted/light-render/lib/utils/set';
import * as lodash from '../utils/lodash';
import { brighten } from '../utils/color';
import merge from '../utils/merge';
import Dataset, { defaultFilter } from '../core/dataset';
import Encode from '../encode';
import { coordType } from '../coord';
import BaseModel from './baseModel';
import { isRichFormat } from '../rich';
import { createPattern } from '../utils/pattern';
import normalizeToArray from '../utils/normalizeToArray';
import { cacheFunction } from '../utils/cache';
import { templateRich } from '../utils/template';
var SeriesModel = /** @class */ (function (_super) {
    __extends(SeriesModel, _super);
    function SeriesModel(type, option, chart, seriesIndex) {
        var _this = _super.call(this) || this;
        _this.stackable = false;
        /**
         * use dataIndex currently
         */
        _this.invisibleItems = new ES6Set();
        _this.selectedItems = new ES6Set();
        _this._patternCache = [];
        _this.type = type;
        _this.chart = chart;
        _this.seriesIndex = seriesIndex;
        _this._initOption(option);
        _this.state = _this.getInitialState();
        return _this;
    }
    // eslint-disable-next-line no-unused-vars
    SeriesModel.prototype.getDefaultOption = function (option) {
        var ret = {
            chunkLimit: 3000,
            chunkMode: 'mod',
            chunkSize: 500,
            hoverBrightness: 0.1,
        };
        return ret;
    };
    SeriesModel.prototype.getInitialState = function () {
        return {
            points: [],
            needAnimation: this.needAnimation(),
        };
    };
    SeriesModel.prototype.getState = function () {
        return this.state;
    };
    SeriesModel.prototype.changeData = function (data) {
        this.option.data = data;
        this._dataset = new Dataset(data);
    };
    SeriesModel.prototype.update = function (nextOption, nextIndex, mergedOld) {
        this._patternCache.length = 0;
        this._seriesPattern = undefined;
        this.invisibleItems.clear();
        this.selectedItems.clear();
        this.seriesIndex = nextIndex;
        this.state.hoverPointIndex = null;
        this._initOption(nextOption, mergedOld);
    };
    SeriesModel.prototype.getDependentComponents = function () {
        var Series = this.constructor;
        return Series.dependencies;
    };
    SeriesModel.prototype.visible = function () {
        return this.option.visible;
    };
    SeriesModel.prototype.toggleVisible = function (visible) {
        this.option.visible = visible;
    };
    SeriesModel.prototype.getHoverColor = function (color) {
        var _a;
        return brighten(color, (_a = this.option.hoverBrightness) !== null && _a !== void 0 ? _a : 0.1);
    };
    SeriesModel.prototype.handleSeriesUIEvent = function (event) {
        var seriesIndex = this.seriesIndex;
        var seriesName = this.option.name;
        this.handleUIEvent(event, 'series', { seriesIndex: seriesIndex, seriesName: seriesName });
    };
    SeriesModel.prototype.getStackOnSeries = function () {
        var _this = this;
        var stackOnSeries = [];
        var currentModel = this;
        this.chart.eachSeriesModel(function (seriesModel) {
            if ((currentModel.option.stack || _this.option.stacking === 'percent') &&
                seriesModel.visible() &&
                seriesModel.type === _this.type &&
                seriesModel.seriesIndex < _this.seriesIndex &&
                seriesModel.getOption().stack === currentModel.option.stack) {
                stackOnSeries.push(seriesModel);
            }
        });
        return stackOnSeries;
    };
    SeriesModel.prototype.getAllPercentStackDatakey = function () {
        var _this = this;
        var allDataKey = [];
        this.chart.eachSeriesModel(function (seriesModel) {
            if (seriesModel.type === _this.type &&
                seriesModel.visible() &&
                seriesModel.getOption().stack === _this.option.stack &&
                seriesModel.getOption().stacking === _this.option.stacking) {
                allDataKey.push(seriesModel.getValueField());
            }
        });
        return allDataKey;
    };
    SeriesModel.prototype.getStackOnDatakey = function () {
        var stackedOnFields = [];
        this.getStackOnSeries().map(function (seriesModel) {
            stackedOnFields = stackedOnFields.concat(seriesModel.getValueField());
        });
        return stackedOnFields;
    };
    // eslint-disable-next-line no-unused-vars
    SeriesModel.prototype.toggleHighlightPoint = function (dataIndex, active, multiple) {
        if (multiple === void 0) { multiple = false; }
        this.state.hoverPointIndex = active ? dataIndex : null;
    };
    SeriesModel.prototype.toggleHighlightSeries = function (active) {
        var _this = this;
        if (this._dataset.count() > this.chart.getOption().animateLimit) {
            return;
        }
        this.state.points.forEach(function (point, pointIndex) {
            return _this.toggleHighlightPoint(pointIndex, active, true);
        });
    };
    SeriesModel.prototype.toggleBlurSeries = function (blur) {
        var _this = this;
        this.state.blur = blur;
        this.state.points.forEach(function (point) { return _this.toggleBlurPoint(point, blur); });
    };
    SeriesModel.prototype.toggleBlurPoint = function (point, blur) {
        var _a, _b, _c, _d, _e;
        point.blur = blur;
        var encodeOpacity = (_a = point.encode) === null || _a === void 0 ? void 0 : _a.opacity;
        encodeOpacity = lodash.isNumber(encodeOpacity) ? encodeOpacity : 1;
        (_c = (_b = point.shapeRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.setAttr({
            opacity: blur ? 0.4 * encodeOpacity : encodeOpacity,
        });
        (_e = (_d = point.labelRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.setAttr({
            opacity: blur ? 0.4 * encodeOpacity : encodeOpacity,
        });
    };
    SeriesModel.prototype.highlightPoint = function (dataIndex) {
        if (this.state.points[dataIndex]) {
            this.state.hoverPointIndex = dataIndex;
            this.toggleHighlightPoint(dataIndex, true);
        }
    };
    SeriesModel.prototype.unhighlightPoint = function (dataIndex) {
        if (this.state.points[dataIndex]) {
            this.state.hoverPointIndex = null;
            this.toggleHighlightPoint(dataIndex, false);
        }
    };
    SeriesModel.prototype.togglePointVisible = function (dataIndex, visible) {
        var shouldVisible = visible;
        if (!lodash.isBoolean(visible)) {
            shouldVisible = this.invisibleItems.has(dataIndex);
        }
        shouldVisible ? this.invisibleItems.delete(dataIndex) : this.invisibleItems.add(dataIndex);
        this.chart.refresh();
    };
    // eslint-disable-next-line no-unused-vars
    SeriesModel.prototype.toggleSelectPoint = function (dataIndex, selected) {
        this.state.points[dataIndex].selected = selected;
        var data = this.state.points[dataIndex].data || this._dataset.getRecord(dataIndex);
        selected ? this.selectedItems.add(data) : this.selectedItems.delete(data);
    };
    SeriesModel.prototype.getSelectedPointIndex = function (item) {
        return this._dataset.getData().indexOf(item);
    };
    SeriesModel.prototype.getSeriesColor = function (withPattern) {
        if (withPattern === void 0) { withPattern = false; }
        var _a;
        if (!this.chart.getOption()) {
            return null;
        }
        var encodeColor = (_a = this.option.encode) === null || _a === void 0 ? void 0 : _a.color;
        if (encodeColor && lodash.isString(encodeColor)) {
            return encodeColor;
        }
        var colors = this.chart.getOption().colors;
        var color = colors[this.seriesIndex % colors.length];
        var pattern = this.option.pattern;
        if (typeof pattern === 'function') {
            pattern = pattern([], color);
        }
        if (pattern && withPattern) {
            if (this._seriesPattern) {
                return this._seriesPattern;
            }
            var patternValue = createPattern(this.getPatternWithColor(pattern, color));
            this._seriesPattern = patternValue;
            return patternValue;
        }
        return color;
    };
    SeriesModel.prototype.getTextStyle = function (option) {
        var conf = _super.prototype.getTextStyle.call(this, option);
        if (this._dataset.count() > 2000 || this.chart.getOption().transition === false) {
            conf.transitionProperty = 'none';
        }
        return conf;
    };
    SeriesModel.prototype.getLineStyle = function (option) {
        var conf = _super.prototype.getLineStyle.call(this, option);
        if (this._dataset.count() > 300 || this.chart.getOption().transition === false) {
            conf.transitionProperty = 'none';
        }
        return conf;
    };
    SeriesModel.prototype.getShapeStyle = function (option) {
        var conf = _super.prototype.getShapeStyle.call(this, option);
        if (this._dataset.count() > 300 || this.chart.getOption().transition === false) {
            conf.transitionProperty = 'none';
        }
        return conf;
    };
    SeriesModel.prototype.getAnimateOption = function () {
        var animate = this.option.animate;
        if (animate && typeof animate === 'object') {
            return animate;
        }
        return {};
    };
    SeriesModel.prototype.getTransitionProperty = function () {
        var count = 0;
        var transition = this.chart.getOption().transition !== false;
        this.chart.getAllSeries().forEach(function (seriesModel) {
            if (seriesModel.visible()) {
                count += seriesModel.getDataset().count();
            }
        });
        return count > 2000 || !transition ? 'none' : 'all';
    };
    SeriesModel.prototype.getChunks = function (items) {
        var _a = this.option, chunkSize = _a.chunkSize, chunkMode = _a.chunkMode;
        if (chunkMode === 'sequential') {
            return lodash.chunk(items, chunkSize);
        }
        if (chunkMode === 'mod') {
            var ret = [];
            var chunkCount = Math.ceil(items.length / chunkSize);
            for (var i = 0; i < items.length; i++) {
                var mod = i % chunkCount;
                if (!ret[mod]) {
                    ret[mod] = [];
                }
                ret[mod].push(items[i]);
            }
            return ret;
        }
        return [items];
    };
    SeriesModel.prototype.needAnimation = function () {
        if (this._dataset.count() > this.chart.getOption().animateLimit) {
            return false;
        }
        if (lodash.isBoolean(this.option.animate)) {
            return this.option.animate;
        }
        return this.chart.getOption().animate;
    };
    SeriesModel.prototype.isLargeData = function () {
        return this._dataset.count() > this.chart.getOption().animateLimit;
    };
    SeriesModel.prototype.getWrappedPoint = function (dataIndex, data) {
        return __assign({ seriesType: this.option.type, seriesIndex: this.seriesIndex, seriesName: this.option.name, seriesColor: this.getSeriesColor(), dataIndex: dataIndex, data: data || this._dataset.getRecord(dataIndex) }, this.state.points[dataIndex]);
    };
    SeriesModel.prototype.wrapPoint = function (point, data) {
        var dataIndex = this.state.points.indexOf(point);
        return this.getWrappedPoint(dataIndex, data);
    };
    SeriesModel.prototype.getDataLabel = function (dataIndex, label) {
        var wrappedPoint = this.getWrappedPoint(dataIndex);
        var formatter = (label || this.option.label).formatter;
        if (lodash.isFunction(formatter)) {
            return formatter(wrappedPoint);
        }
        if (lodash.isString(formatter) || isRichFormat(formatter)) {
            return this.formatItem(formatter, wrappedPoint);
        }
        var value = wrappedPoint.value;
        if (lodash.isNull(value) || lodash.isUndefined(value)) {
            return '';
        }
        return wrappedPoint.value.toString();
    };
    SeriesModel.prototype.getEdgePosition = function (side, margin, labelSize) {
        var width = this.chart.getWidth();
        var height = this.chart.getHeight();
        if (side === 'left') {
            return margin + labelSize.width;
        }
        if (side === 'right') {
            return width - labelSize.width - margin;
        }
        if (side === 'top') {
            return margin + labelSize.height;
        }
        if (side === 'bottom') {
            return height - labelSize.height - margin;
        }
    };
    SeriesModel.prototype.isLabelInside = function (labelOption) {
        var position = (labelOption || this.option.label).position;
        return position === 'center' || position.indexOf('inside') !== -1;
    };
    SeriesModel.prototype.formatItem = function (formatter, param) {
        if (lodash.isFunction(formatter)) {
            return formatter(param);
        }
        if (lodash.isString(formatter) || isRichFormat(formatter)) {
            return templateRich(formatter, param);
        }
        return formatter;
    };
    SeriesModel.prototype.getPointFillWithPattern = function (point, dataIndex) {
        var pattern = this.option.pattern;
        if (!pattern) {
            return point.color;
        }
        if (this._patternCache[dataIndex]) {
            return this._patternCache[dataIndex];
        }
        var data = this._dataset.getRecord(dataIndex);
        var patternOption = typeof pattern === 'function' ? pattern(data, point.color) : pattern;
        var patternValue = createPattern(this.getPatternWithColor(patternOption, point.color));
        this._patternCache[dataIndex] = patternValue;
        return patternValue;
    };
    SeriesModel.prototype.getValueField = function () {
        var chartOption = this.chart.getOption();
        var _a = this.option, coord = _a.coord, xAxis = _a.xAxis, yAxis = _a.yAxis, polar = _a.polar;
        if (coord === coordType.CARTESIAN2D) {
            if (chartOption.yAxis[yAxis].type !== 'category') {
                return this._encode.getAxisField('yAxis');
            }
            if (chartOption.xAxis[xAxis].type !== 'category') {
                return this._encode.getAxisField('xAxis');
            }
        }
        else if (coord === coordType.POLAR) {
            var angleAxis = chartOption.angleAxis.filter(function (axis) { return axis.polar === polar; })[0];
            var radiusAxis = chartOption.radiusAxis.filter(function (axis) { return axis.polar === polar; })[0];
            if (radiusAxis.type !== 'category') {
                return this._encode.getAxisField('radiusAxis');
            }
            if (angleAxis.type !== 'category') {
                return this._encode.getAxisField('angleAxis');
            }
        }
        return '';
    };
    SeriesModel.prototype.getAxisOption = function (axis) {
        var chartOption = this.chart.getOption();
        var option = this.option;
        var _a = this.option, coordinateSystem = _a.coord, polar = _a.polar;
        if (coordinateSystem === coordType.CARTESIAN2D) {
            return this.chart.getOption()[axis][option[axis]];
        }
        if (coordinateSystem === coordType.POLAR) {
            var angleAxis = chartOption.angleAxis.filter(function (axisItem) { return axisItem.polar === polar; })[0];
            var radiusAxis = chartOption.radiusAxis.filter(function (axisItem) { return axisItem.polar === polar; })[0];
            if (axis === 'angleAxis') {
                return angleAxis;
            }
            if (axis === 'radiusAxis') {
                return radiusAxis;
            }
        }
    };
    SeriesModel.prototype.destroy = function () {
        this._patternCache.length = 0;
        _super.prototype.destroy.call(this);
    };
    SeriesModel.prototype.getCategories = function (field) {
        if (this.type === 'heatmap' || this.type === 'scatter') {
            return this._dataset.uniq(field);
        }
        if (this.type === 'waterfall') {
            var option = this.option;
            if (option.total) {
                var values = this._dataset.getFieldData(field);
                values.push(option.total.label);
                return values;
            }
        }
        return this._dataset.getFieldData(field);
    };
    SeriesModel.prototype.getExtreme = function (datakey, filter) {
        if (filter === void 0) { filter = defaultFilter; }
        var dataset = this.getDataset();
        var dataKeys = normalizeToArray(datakey);
        var min = lodash.min(dataKeys.map(function (key) { return dataset.min(key, filter); }));
        var max = lodash.max(dataKeys.map(function (key) { return dataset.max(key, filter); }));
        return [min, max];
    };
    SeriesModel.prototype.getCoord = function () {
        var coordModle = this.chart.getComponentModel('coord');
        return coordModle.getCoordinate(this.option);
    };
    SeriesModel.prototype.getStackedExtreme = function (dataKeySet, axis, allData) {
        var _this = this;
        if (allData === void 0) { allData = false; }
        var keyArray = normalizeToArray(dataKeySet);
        var datakey = keyArray[0];
        var filterField;
        var filterAxisOption;
        var valueAxisOption;
        if (axis === 'xAxis') {
            filterAxisOption = this.getAxisOption('yAxis');
            valueAxisOption = this.getAxisOption('xAxis');
            filterField = this.option.encode.y;
        }
        else if (axis === 'yAxis') {
            filterAxisOption = this.getAxisOption('xAxis');
            valueAxisOption = this.getAxisOption('yAxis');
            filterField = this.option.encode.x;
        }
        else if (axis === 'angleAxis') {
            filterAxisOption = this.getAxisOption('radiusAxis');
            valueAxisOption = this.getAxisOption('angleAxis');
            filterField = this.option.encode.radius;
        }
        else if (axis === 'radiusAxis') {
            filterAxisOption = this.getAxisOption('angleAxis');
            valueAxisOption = this.getAxisOption('radiusAxis');
            filterField = this.option.encode.angle;
        }
        var min = filterAxisOption.min, max = filterAxisOption.max;
        var isCategory = filterAxisOption.type === 'category';
        var filter = allData
            ? defaultFilter
            : this._getFieldFilter(filterField, isCategory, min, max, valueAxisOption.autoRange);
        var stackedOnFields = this.getStackOnDatakey();
        if (this.option.stacking === 'percent') {
            return [0, 100];
        }
        // interval stack
        if (this.type === 'waterfall') {
            var isSum_1 = this.option.isSum;
            var flatValues = lodash.flatten(this.getDataset().intervalStack(datakey, function (record, index) {
                return !(_this.invisibleItems.has(index) || (isSum_1 && isSum_1(record)));
            }));
            return [lodash.min(flatValues), lodash.max(flatValues)];
        }
        // self stack
        if (this.type === 'streamgraph') {
            var stackFields = this.option.encode.y.filter(function (y) {
                return !_this.hideLegendItems.has(y);
            });
            var values = this._dataset.sumFields(stackFields);
            return [lodash.min(values), lodash.max(values)];
        }
        // range area
        if (lodash.isArray(dataKeySet) ||
            !this.stackable ||
            lodash.isNull(this.option.stack) ||
            lodash.isUndefined(this.option.stack)) {
            return this.getExtreme(dataKeySet, filter);
        }
        var dataset = this.getDataset();
        return dataset.getStackedExtreme(dataKeySet, stackedOnFields, filter);
    };
    SeriesModel.prototype.getDataset = function () {
        return this._dataset;
    };
    SeriesModel.prototype.getEncoder = function () {
        return this._encode;
    };
    SeriesModel.prototype.getFacetBBox = function () {
        return this.chart.getFacetContentBox(this.option.facet);
    };
    SeriesModel.prototype.handleDefaultEvent = function (event, dataType, data) {
        var _this = this;
        var _a;
        var chart = this.chart;
        if (event.type === 'mouseover' && (dataType === 'point' || dataType === 'label')) {
            this.highlightPoint(data.point.dataIndex);
        }
        if (event.type === 'mouseout' && (dataType === 'point' || dataType === 'label')) {
            if (data.hasAxis) {
                var triggerByAxis = ((_a = chart.getComponentModel('tooltip')) === null || _a === void 0 ? void 0 : _a.getOption().trigger) === 'axis';
                if (triggerByAxis) {
                    return;
                }
            }
            this.unhighlightPoint(data.point.dataIndex);
        }
        if (event.type === 'click' && dataType === 'point') {
            var currentSelected = this.selectedItems.has(data.point.data);
            var selectedMode = this.getOption().selectedMode;
            if (!selectedMode) {
                return;
            }
            if (selectedMode === 'single') {
                this.selectedItems.forEach(function (item) {
                    var dataIndex = _this.getSelectedPointIndex(item);
                    if (dataIndex !== data.point.dataIndex) {
                        _this.toggleSelectPoint(dataIndex, false);
                    }
                });
                if (!currentSelected) {
                    this.toggleSelectPoint(data.point.dataIndex, true);
                    var eventType = 'point:selected';
                    chart.dispatchAction(__assign(__assign({}, data), { type: eventType }));
                }
                else if (this.type === 'pie' && !this.option.selectedRotate) {
                    this.toggleSelectPoint(data.point.dataIndex, false);
                    var eventType = 'point:unselected';
                    chart.dispatchAction(__assign(__assign({}, data), { type: eventType }));
                }
            }
            if (selectedMode === 'multiple') {
                this.toggleSelectPoint(data.point.dataIndex, !currentSelected);
                var eventType = !currentSelected ? 'point:selected' : 'point:unselected';
                chart.dispatchAction(__assign(__assign({}, data), { type: eventType }));
            }
            var arr_1 = [];
            this.selectedItems.forEach(function (item) { return arr_1.push(item); });
            this.chart.dispatchAction({
                type: 'selectchanged',
                seriesIndex: this.seriesIndex,
                selected: arr_1,
            });
        }
    };
    SeriesModel.prototype.handleUIEvent = function (event, dataType, data) {
        this.handleDefaultEvent(event, dataType, data);
        _super.prototype.handleUIEvent.call(this, event, dataType, data);
    };
    SeriesModel.prototype._getFieldFilter = function (filterField, isCategory, min, max, autoRange) {
        return function (record, dataIndex) {
            var flagMin = true;
            var flagMax = true;
            if (lodash.isNumber(min) && autoRange) {
                flagMin = isCategory
                    ? dataIndex >= (isCategory ? Math.round(min) : min)
                    : record[filterField] >= min;
            }
            if (lodash.isNumber(max) && autoRange) {
                flagMax = isCategory
                    ? dataIndex <= (isCategory ? Math.round(max) : max)
                    : record[filterField] <= max;
            }
            return flagMin && flagMax;
        };
    };
    SeriesModel.prototype._initOption = function (option, mergedOld) {
        if (mergedOld === void 0) { mergedOld = false; }
        var sourceOption = mergedOld ? this.option : this.getDefaultOption(option);
        this.option = merge(sourceOption, this.getThemeOption(), option);
        this.type = this.option.type;
        this._dataset = new Dataset(this.option.data || this.chart.getDataSource());
        this._encode = new Encode(this.option.encode || {}, this);
        this._getFieldFilter = cacheFunction(this._getFieldFilter.bind(this), 10);
        this.chart.getOption().series[this.seriesIndex] = this.option;
        this._initDefaultState();
    };
    SeriesModel.prototype.getStateTestData = function () {
        return this._dataset.getData();
    };
    SeriesModel.prototype._initDefaultState = function () {
        var _this = this;
        var defaultState = this.option.defaultState;
        if (!defaultState) {
            return;
        }
        this.getStateTestData().forEach(function (item, index) {
            if (defaultState.selected && defaultState.selected(item, index)) {
                _this.selectedItems.add(item);
            }
            if (defaultState.visible && !defaultState.visible(item, index)) {
                _this.invisibleItems.add(index);
            }
        });
    };
    SeriesModel.prototype.getPatternWithColor = function (inOption, color) {
        var defaultColor = 'rgba(255, 255, 255, .5)';
        var defaultPattern = {
            backgroundColor: color,
            style: {
                fill: defaultColor,
                stroke: defaultColor,
            },
        };
        var patternOption = merge(defaultPattern, inOption);
        return patternOption;
    };
    SeriesModel.dependencies = [];
    return SeriesModel;
}(BaseModel));
export default SeriesModel;
